import StripePlanMetadata from '@/datatypes/stripe/plan-metadata';

export default class StripePlan {
  public id: string;
  public active: string;
  public amount: string;
  public billingScheme: string;
  public interval: string;
  public intervalCount: number;
  public metadata: StripePlanMetadata;
  public usageType: string;
  public aggregateUsage: string;
  public tiers;
  public tiersMode: string;

  constructor(options) {
    this.id = options.id;
    this.active = options.active;
    this.amount = options.amount;
    this.billingScheme = options.billingScheme;
    this.interval = options.interval;
    this.intervalCount = options.intervalCount;
    this.metadata = options.metadata;
    this.usageType = options.usageType;
    this.aggregateUsage = options.aggregateUsage;
    this.tiersMode = options.tiersMode;
    this.tiers = options.tiers;
  }

  wrongAggregate() {
    if (this.usageType !== 'metered') return false;

    return (this.aggregateUsage !== 'last_during_period');
  }
}
